export const SELECTION_DEFAULT_DISTINCT_COLOURS = [
	'#42d4f4',
	'#e15dda',
	'#f58231',
	'#e6194B',
	'#25b537',
	'#4363d8',
	'#6a632f',
	'#aaffc3',
	'#9A6324',
	'#dcbeff',
	'#fffac8',
	'#ff9ec1',
	'#800000',
	'#11bda3',
	'#911eb4',
	'#bfef45',
	'#808000',
	'#ffd8b1',
	'#282892',
];

export const SELECTION_DEFAULT_COLOUR = '#00ffff';
